exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#model-tree[data-v-454a1428]{background-color:transparent}#model-tree[data-v-454a1428]  .el-button{color:#fff!important}[data-v-454a1428] .el-loading-mask{height:calc(100% - 42px);background-color:rgba(0,0,0,.5)!important}", ""]);

// exports
